module.exports = __webpack_public_path__ + "img/28.0ceb6748.jpg";